import * as Yup from 'yup';
import { AccessorAndParent } from '../NotificationsPage';

const vesselPortValidationSchema = Yup.object().shape({
  mmsi: Yup.string()
    .required('Error_IsRequired')
    .matches(/^([0-9]*)$/, 'Error_OnlyNumbers')
    .min(9, 'Error_NineDigits')
    .max(9, 'Error_NineDigits'),

  any: Yup.boolean(),
  isItemSelected: Yup.boolean(),
  port: Yup.string().when('any', {
    is: false,
    then: Yup.string().required('Error_IsRequired'),
  }),
});

const vasselTargetSafetyValidationSchema = Yup.object().shape({
  mmsi: Yup.string().when('fleet', {
    is: false,
    then: Yup.string().notRequired(),
  }),
  fleet: Yup.boolean(),
});

const vesselAreaValidationSchema = Yup.object().shape({
  mmsi: Yup.string()
    .required('Error_IsRequired')
    .matches(/^([0-9]*)$/, 'Error_OnlyNumbers')
    .min(9, 'Error_NineDigits')
    .max(9, 'Error_NineDigits'),
  any: Yup.boolean(),
  isItemSelected: Yup.boolean(),
  area: Yup.string().when('any', {
    is: false,
    then: Yup.string().required('Error_IsRequired'),
  }),
});

const portValidationSchema = Yup.object().shape({
  isItemSelected: Yup.boolean(),
  any: Yup.boolean(),
  mmsi: Yup.string()
    .nullable()
    .matches(/^([0-9]*)$/, 'Error_OnlyNumbers')
    .min(9, 'Error_NineDigits')
    .max(9, 'Error_NineDigits')
    .when('any', {
      is: false,
      then: Yup.string().required('Error_IsRequired'),
    }),
  port: Yup.string().required('Error_IsRequired'),
});

const areaValidationSchema = Yup.object().shape({
  isItemSelected: Yup.boolean(),
  any: Yup.boolean(),
  mmsi: Yup.string().when('any', {
    is: false,
    then: Yup.string()
      .required('Error_IsRequired')
      .matches(/^([0-9]*)$/, 'Error_OnlyNumbers')
      .min(9, 'Error_NineDigits')
      .max(9, 'Error_NineDigits'),
  }),
  area: Yup.string().required('Error_IsRequired'),
});

export const getSchema = (parent: AccessorAndParent, accessor: AccessorAndParent) => {
  switch (parent) {
    case AccessorAndParent.Port:
      return portValidationSchema;
    case AccessorAndParent.Vessel:
      return accessor === AccessorAndParent.Port
        ? vesselPortValidationSchema
        : accessor === AccessorAndParent.TargetSafety
          ? vasselTargetSafetyValidationSchema
          : vesselAreaValidationSchema;
    case AccessorAndParent.Area:
      return areaValidationSchema;
  }
};
